import BaseModel from "models/base.model";

export default class SearchResult extends BaseModel {
	static endpoint = "documents.json";

	path;
	title;
	content;

	promiseFetch(options = {}) {
		throw new Error("fetch is not allowed on documents");
	}

	promiseCreate(options = {}) {
		throw new Error("create is not allowed on documents");
	}

	promiseSave(options = {}) {
		throw new Error("save is not allowed on documents");
	}

	promiseDestroy(options = {}) {
		throw new Error("destroy is not allowed on documents");
	}
}
